import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SharedNavbar from '../components/SharedNavbar';
import dmbok from '../assets/images/DAMA-DMBOK.png';
import './NewsPage.css';

const categories = [
  'AI and ML',
  'Conference',
  'DAMA Tunisia Updates',
  'Data Architecture',
  'Data Governance',
  'Data Management',
  'Data Maturity',
  'Data Modelling and Design',
  'Data Privacy',
  'Data Quality',
  'Data Security',
  'Data Storage and Operations',
  'Data Strategy',
  'Data Warehousing and Business Intelligence',
  'Document and Content Management',
  'Learning and Development',
  'Meet Ups',
  'Newsletter',
  'Public',
  'Reference and Master Data',
  'Webinars',
];

const NewsPage = () => {
  const [activeCategory, setActiveCategory] = useState(null);

  return (
    <div className="news-page">
      <SharedNavbar />

      {/* ===== HERO ===== */}
      <section className="news-hero">
        <div className="news-hero-content">
          <h1>News</h1>
          <p>
            Your trusted source for insights, updates, and discussions on
            data management best practices, emerging trends, and industry news.
          </p>
        </div>
      </section>

      {/* ===== BODY ===== */}
      <section className="news-body">
        <div className="news-container">
          <div className="news-layout">

            {/* ── SIDEBAR ── */}
            <aside className="news-sidebar">
              <h2>Categories</h2>
              <ul>
                {categories.map((cat) => (
                  <li
                    key={cat}
                    className={activeCategory === cat ? 'active' : ''}
                    onClick={() => setActiveCategory(activeCategory === cat ? null : cat)}
                  >
                    {cat}
                  </li>
                ))}
              </ul>
            </aside>

            {/* ── CONTENU PRINCIPAL ── */}
            <div className="news-main">

              {/* Notice */}
              <div className="news-notice">
                <p>
                  <strong>
                    Stay tuned — DAMA Tunisia is working on bringing you the latest news,
                    articles and newsletters. Check back soon for updates!
                  </strong>
                </p>
              </div>

              {/* DMBoK promo */}
              <div className="news-dmbok-promo">
                <div className="news-dmbok-text">
                  <p>
                    <strong>Interested in DMBoK® 3?</strong> — DAMA International is developing
                    DMBoK® 3.0, the next evolution of the Data Management Body of Knowledge.
                    Visit our{' '}
                    <Link to="/dmbok3" className="news-link-btn">
                      <strong>DMBoK® 3 updates</strong>
                    </Link>{' '}
                    page to learn more about the project, access webinar updates, and see
                    future opportunities that may be relevant for DAMA Tunisia members.
                  </p>
                </div>
                <div className="news-dmbok-img">
                  <Link to="/dmbok">
                    <img src={dmbok} alt="DAMA DMBoK" />
                  </Link>
                </div>
              </div>

              {/* Catégorie sélectionnée */}
              {activeCategory && (
                <div className="news-cat-selected">
                  <h3>Category: <span>{activeCategory}</span></h3>
                  <p>No articles available in this category yet. Check back soon!</p>
                  <button
                    onClick={() => setActiveCategory(null)}
                    className="news-reset-btn"
                  >
                    ← View all categories
                  </button>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="news-cta">
        <div className="news-container">
          <div className="news-cta-grid">
            <Link to="/membership" className="news-cta-btn">
              <strong>Become a member</strong>
              <span>Join today and access all our resources</span>
            </Link>
            <Link to="/events" className="news-cta-btn">
              <strong>Events</strong>
              <span>Discover upcoming and past events</span>
            </Link>
            <Link to="/about" className="news-cta-btn">
              <strong>Sponsor us</strong>
              <span>Connect with the Tunisian data community</span>
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default NewsPage;